import {useId} from 'react';

import PopupSticked from '@/components/Popup/PopupSticked';

import {useRescheduleFlow} from '../RescheduleFlowContext';
import {RESCHEDULE_STEPS} from '../reschedulePopupSteps';
import RescheduleConfirmationStep from './RescheduleConfirmationStep';

const RescheduleConfirmationPopup = () => {
    const popupTitleId = useId();
    const {step, selectedFrequency, selectedDate, isSubmitting, handleBack, handleConfirm} = useRescheduleFlow();

    if (step !== RESCHEDULE_STEPS.CONFIRMATION || !selectedDate) {
        return null;
    }

    return (
        <PopupSticked
            className='text-start ml:pt-18'
            isOpen
            onClose={handleBack}
            isCloseVisible
            aria-labelledby={popupTitleId}
        >
            <RescheduleConfirmationStep
                selectedFrequency={selectedFrequency}
                selectedDate={selectedDate}
                onConfirm={handleConfirm}
                isLoading={isSubmitting}
                titleId={popupTitleId}
            />
        </PopupSticked>
    );
};

export default RescheduleConfirmationPopup;
